import { fetcher } from 'webapp-common';

const SESSION_INFO_URL = '/a/api/sessionInfo';

export const fetchSessionUser = () => fetcher.get(SESSION_INFO_URL);
